import { Routes } from '@angular/router';

export const contactRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./contact.page').then(m => m.ContactPage)
    },
    {
        path: 'my-profile',
        loadComponent: () => import('./pages/my-profile/my-profile.page').then(m => m.MyProfilePage),
    },
    {
        path: 'amy-profile',
        loadComponent: () => import('./pages/aadhar-my-profile/aadhar-my-profile.page').then(m => m.AadharMyProfilePage),
    },
    {
        path: 'aland',
        loadComponent: () => import('./pages/aadhar-land-detail/aadhar-land-detail.page').then(m => m.AadharLandDetailPage),
    },
    {
        path: 'single-land-detail',
        loadComponent: () => import('./pages/aadhar-land-detail/each-land-detail/each-land-detail.page').then(m => m.EachLandDetailPage),
    },
    {
        path: 'asoil',
        loadComponent: () => import('./pages/aadhar-soil-details/aadhar-soil-details.page').then(m => m.AadharSoilDetailsPage),
    },
      {
        path: 'soil-card',
        loadComponent: () => import('./pages/aadhar-soil-details/soil-card/soil-card.page').then(m => m.SoilCardPage),
    },
    {
        path: 'acrop',
        loadComponent: () => import('./pages/aadhar-crop-details/aadhar-crop-details.page').then(m => m.AadharCropDetailsPage),
    },
    {
        path: 'applied-scheme',
        loadComponent: () => import('./pages/aadhar-applied-scheme/aadhar-applied-scheme.page').then(m => m.AadharAppliedSchemePage),
    },
    {
        path: 'my-farm',
        loadComponent: () => import('./pages/my-farm/my-farm.page').then(m => m.MyFarmPage),
    },
    {
        path: 'crop-details',
        loadComponent: () => import('./pages/my-farm/crop-details/crop-details.page').then(m => m.CropDetailsPage),
    },
    {
        path: 'land-details',
        loadComponent: () => import('./pages/my-farm/land-details/land-details.page').then(m => m.LandDetailsPage),
    },
    {
        path: 'farm-guide',
        loadComponent: () => import('./pages/farm-guide/farm-guide.page').then(m => m.FarmGuidePage),
    },
    {
        path: 'feedback',
        loadComponent: () => import('./pages/feeedback/feeedback.page').then(m => m.FeeedbackPage),
    },
    {
        path: 'my-activity',
        loadComponent: () => import('./pages/my-activity/my-activity.page').then(m => m.MyActivityPage),
    },

    {
        path: 'other-settings',
        loadComponent: () => import('./pages/other-settings/other-settings.page').then(m => m.OtherSettingsPage),
    },
    {
        path: 'change-password',
        loadComponent: () => import('./pages/other-settings/change-password/change-password.page').then(m => m.ChangePasswordPage),
    },
]